type CodedErrorLike = { data?: { error?: { code?: unknown } } };

export const readErrorCode = (error: unknown): string | null => {
  const body = (error as CodedErrorLike)?.data?.error;

  if (typeof body?.code !== "string") return null;

  return body.code;
};
